import { HttpBillList, HttpExportBill, HttpChangeBillStatus } from '@/service/salesreturns';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import compAdd from './add';
import compIndex from './update';
import mixin from '../mixin'

export default {
    mixins: [TableList, mixin],
    components: {
        compAdd,
        compIndex
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpBillList,
        handleOperates(params, type) {
            // if (batch === true) {
            //     params = (params || this.checkedData.join(',')) + '';
            //     if (!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: "请选择至少一条数据" }));
            // }
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpExportBill, this.formData, { executor: 'request', download: true });
                    break;
                case 'add':
                    this.operate = {
                        show: true,
                        title: "添加",
                        component: "compAdd",
                        width: "large",
                        showFooter: false
                    }
                    break;
                // case 'query':
                //     window.open(this.$router.resolve({
                //         name: "salesreturnsBillUpdate",
                //         params: { type: 'query' },
                //         query: { id: params },
                //     }).href, '_blank');
                //     break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeids: params,
                        activeType: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "salesreturnsBillUpdate",
                        params: { type: 'query' },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'edit':
                    this.$router.push({
                        name: 'salesreturnsBillUpdate',
                        params: { type: 'edit' },
                        query: { id: params },
                    })
                    break;
                case 'confirm':
                    this.operate = {
                        show: true,
                        title: "确认",
                        alert: "success",
                        showDesc: false,
                        width: "middle",
                        params: { id: params, status: 70, },
                        ajaxRequest: HttpChangeBillStatus,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "message",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                required: false
                            }
                        ]
                    }
                    break;
                case 'cancel':
                    this.operate = {
                        show: true,
                        title: "取消",
                        alert: "error",
                        width: "middle",
                        showDesc: false,
                        params: { id: params, status: 90, },
                        ajaxRequest: HttpChangeBillStatus,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "message",
                                labelWidth: 'auto',
                                span: 24,
                                label: "取消原因",
                                // required: false
                            }
                        ]
                    }

            }
        },
        getOperateNodeMap(row) {
            const { id, saleReturnOrderStatus } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: "查看" }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: "编辑" }),
                show: saleReturnOrderStatus == 0 && this.handleAuth('fbb.returninbound.edit'),
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.update_OK', { defaultValue: "确认" }),
                show: saleReturnOrderStatus == 0 && this.handleAuth('fbb.returninbound.edit'),
                params: id,
                operate: 'confirm'
            }, {
                label: this.$t('global.common.cancel', { defaultValue: "取消" }),
                show: saleReturnOrderStatus == 0 && this.handleAuth('fbb.returninbound.edit'),
                params: id,
                operate: 'cancel'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList', 'getUserManageWarehouseList','getBillcusWareList']),
        ToolsData() {
            return [{
                name: this.$t('global.common.add', { defaultValue: "添加" }),
                operate: "add",
                show: this.handleAuth('fbb.returninbound.edit'),
                theme: 'primary'
            }, {
                name: this.$t('global.common.export', { defaultValue: "导出" }),
                show: this.handleAuth('fbb.returninbound.export'),
                operate: "export",
            }]
        },
        SearchsData() {
            let widthStyle = 'width: 218px;'
            return [
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    tag: 'Select',
                    options: this.getCusproductList,
                    show: true,
                    props: {
                        filterable: true,
                    },
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('', { defaultValue: "退货入库单号" }),
                    key: 'EQ_saleReturnOrderNo',
                    show: true,
                    tag: 'vInput',
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('', { defaultValue: "退货计划单号" }),
                    key: 'EQ_saleReturnPlanOrderNo',
                    show: true,
                    tag: 'vInput',
                    style: 'width: 172px; margin-right:20px',
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_orgWarehouseCode',
                    tag: 'Select',
                    options: this.getUserManageWarehouseList.map(item => {
                        return {
                            label: item.label,
                            value: item.attach.code
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    key: 'EQ_organizationId',
                    tag: 'Select',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: 'EQ_saleReturnOrderStatus',
                    tag: 'Select',
                    options: this.getBillStatus,
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.sourceNo', { defaultValue: "来源单号" }),
                    key: 'EQ_sourceNo',
                    tag: 'vInput',
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                // {
                //     type: 'selection',
                //     formName: 'id',
                //     width: 60,
                // },
                {
                    title: this.$t('global.common.operate', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    key: 'organizationId',
                    render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.organizationId)||'--'
                },
                {
                    title: this.$t('', { defaultValue: "退货入库单号" }),
                    key: 'saleReturnOrderNo',
                    render: (h, { row }) => {
                        return <div>
                            <a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.saleReturnOrderNo}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                    }
                },
                {
                    title: this.$t('global.common.sourceNo', { defaultValue: "来源单号" }),
                    key: 'sourceNo',
                    render:(h,{row})=>{
                        return row.sourceNo || '--'
                    }
                },
                {
                    title: this.$t('', { defaultValue: "退货计划单号" }),
                    key: 'saleReturnPlanOrderNo',
                    render:(h,{row})=>{
                        return row.saleReturnPlanOrderNo || '--'
                    }
                },
                {
                    title: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: 'status',
                    render: (h, { row }) => {
                        const status = row.saleReturnOrderStatus;
                        const { label = '', theme = '' } = this.getBillStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vTag color={theme} type="border">{label}</vTag>
                    }
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'orgWarehouseCode',
                    render:( h, { row })=>{
                        const wareHouse=this.getUserManageWarehouseList.filter(item=>item.attach.code===row.orgWarehouseCode)
                        return <div>{ wareHouse[0] ? wareHouse[0].label : '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'lineId',
                    render: (h, { row }) => {return this.findRenderLabel(this.getCusproductList, row.lineId) || '--'}
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    key: 'updatedAt',
                }];
        },
    },
};




